const languageSelectors = document.querySelectorAll('[data-language_selector]');
if (languageSelectors.length) {
  languageSelectors.forEach(initLanguageSelector);
}

function initLanguageSelector(selector) {
  const type = selector.dataset.type;
  const form = document.querySelector(`[data-selector_form="${selector.dataset.form}"]`);
  const input = form.querySelector('[data-form_value]');
  if (type === 'select') handleLanguageSelect(selector, form, input);
}

function handleLanguageSelect(selector, form, input) {
  selector.addEventListener('change', (event) => updateLanguageSelector(form, input, event.target.value));
}

function handleLanguageList(selector, form, input) {
  const options = selector.querySelectorAll('[data-value]');
  if (!options.length) return console.warn('Language list selector has no available options');
  options.forEach((option) => {
    option.addEventListener('click', (event) => {
      event.preventDefault();
      updateLanguageSelector(form, input, option.dataset.value);
    });
  });
}

function updateLanguageSelector(form, input, value) {
  input.value = value;
  form.submit();
}
